export const GAME_PROVIDER_ERRORS_CODE = {
  gameDisabled: 1
}
